import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import CountryForm from '../containers/CountryFormContainer';
import DocumentHead from '../../../../elements/components/DocumentHead';
import Logger from '../../../../../../lib/Logger';

class CountryAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CountryAdd.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('country_route_add')} />
          <CountryForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CountryAddScreen;

Logger.log('silly', `CountryAddScreen loaded.`);
